import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadAmpManifestService } from './services/load-amp-manifest.service';

import { InlineSVGModule } from 'ng-inline-svg';
import { RouterModule } from '@angular/router';
import { FLXDetailsComponent } from './views/details-view/details-view.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FLXListViewComponent } from './views/list-view/list-view.component';
import { AmpService, ClaimService, JobService } from './services';
import { UIElementsModule } from '@flexus/ui-elements';
import { ThemeModule } from '@flexus/ux';

import { environment } from '../../../environments/environment';
import { UICompositesModule } from '@flexus/ui-composites';
import { ErrorHandlerModule } from '@flexus/error-handler';
import { ScreensModule } from '@flexus/screens';
import { ActivateStateGuard } from './guards/activate-state.guard';
import { DeactivateStateGuard } from './guards/deactivate-state.guard';
import { AmpClaimCardComponent } from './components/amp-claim-card/amp-claim-card.component';
import { AmpListJobCardComponent } from './components/amp-list-job-card/amp-list-job-card.component';
import { AmpListClaimCardComponent } from './components/amp-list-claim-card/amp-list-claim-card.component';
import { AmpWorkflowShellComponent } from './base-components/amp-workflow-shell/amp-workflow-shell.component';
import { AmpFlowComponent } from './base-components/amp-flow/amp-flow.component';
import { AmpJobCardComponent } from './components/amp-job-card/amp-job-card.component';
import { MsalModule } from '@azure/msal-angular';
import { SearchBannerModule } from '../../app-shell-features';
import { PublicClientApplication } from '@azure/msal-browser';
import { DynamicLoaderModule } from '@flexus/engine';
import { IdentityModule } from '@flexus/identity';


export function loadConfig(manifest: LoadAmpManifestService) {
	return function () {
		return manifest.load();
	};
}
@NgModule({
	imports: [
		CommonModule,
		...environment.appShellFeatures,
		DynamicLoaderModule,
		ErrorHandlerModule,
		ScreensModule,
		InlineSVGModule,
		NgxPaginationModule,
		RouterModule,
		ThemeModule,
		...environment.plugins['global'],
		UIElementsModule.forRoot({ environment: environment }),
		UICompositesModule,
		environment['azure']
			? MsalModule.forRoot(
					new PublicClientApplication({
						auth: {
							clientId: environment['azure']['clientId'],
							postLogoutRedirectUri: `${environment.base_url}auth/login`
						}
					}),
					null,
					null
			  )
			: CommonModule,
		IdentityModule.forRoot({
			after_login_url: '/workflow',
			after_logout_url: '/auth/login',
			send_reset_link_endpoint: `${environment.api_url}v1/forgot_password/check-email`,
			login_endpoint: `${environment.api_url}v2/auth/login/`,
			no_auth_urls: ['/cons']
		}),
		SearchBannerModule
	],
	declarations: [
		AmpClaimCardComponent,
		AmpListClaimCardComponent,
		AmpJobCardComponent,
		AmpListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent,
		AmpWorkflowShellComponent,
		AmpFlowComponent
	],
	exports: [
		...environment.appShellFeatures,
		AmpClaimCardComponent,
		AmpJobCardComponent,
		AmpListClaimCardComponent,
		AmpListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent
	],
	providers: [
		ActivateStateGuard,
		DeactivateStateGuard,
		AmpService,
		ClaimService,
		JobService,
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [LoadAmpManifestService],
			multi: true
		}
	]
})
export class AmpManifestModule {}
